const PROBLEM_TYPE_LABELS = {
  substitution: "Substitution",
  "u-sub": "Substitution",
  u_sub: "Substitution",
  "integration by parts": "Integration – by parts",
  integration_by_parts: "Integration – by parts",
  "integration-by-parts": "Integration – by parts",
  "trig integrals": "Trig integrals",
  trig_integrals: "Trig integrals",
  "trig substitution": "Trig substitution",
  trig_substitution: "Trig substitution",
  "partial fractions": "Partial fractions",
  partial_fractions: "Partial fractions",
  "p-series": "p-series",
  p_series: "p-series",
  "ratio test": "Ratio test",
  ratio_test: "Ratio test",
  "series – ratio test": "Ratio test",
  "series comparison": "Series comparison",
  series_comparison: "Series comparison",
  other: "Other",
};

export const normalizeProblemType = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  const lower = trimmed.toLowerCase();
  return PROBLEM_TYPE_LABELS[lower] || trimmed;
};
